<template>
  <div class="download_nav" :class="ifShow ? 'show' : 'hide'">
    <div class="content">
      <div class="logo"></div>
      <a class="btn" @click="openApp">App内打开</a>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "../../assets/scss/mixin.scss";
.download_nav {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  .content {
    height: 88px;
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include hairline(bottom, #eee);
    .logo {
      width: 248px;
      height: 48px;
      background-image: url(./imgs/logo.png);
      background-size: contain;
      background-repeat: no-repeat;
    }
  }

  position: fixed !important;
  left: 50%;
  top: 0;
  z-index: 1000000 !important;

  transition: 0.4s ease;

  &.show {
    transform: translate(-50%, 0px);
  }

  &.hide {
    transform: translate(-50%, -200px);
  }

  &::after {
    content: "";
    position: absolute;
    z-index: -1;
  }
}
// .tip{
//     flex:1;
//     padding-top: 100px;
//     padding-left: 206px;
//     @include px2px('font-size',22);
//     color: #999;
//     line-height: 1;
// }
.btn {
  display: block;
  width: 168px;
  height: 48px;
  line-height: 48px;
  background: #1daaf7;
  text-align: center;

  color: #fff;
  border-radius: 100px;
  @include px2px("font-size", 26);
  text-decoration: none;
  &:active {
    opacity: 0.8;
  }
}
</style>

<script>
import { magicLink } from "@/untils/until.js";

export default {
  data() {
    return {};
  },
  created() {},
  props: ["ifShow"],
  methods: {
    openApp() {
      let self = this;
      switch (self.$route.name) {
        case "newTopic":
          magicLink(
            "po_tag",
            window.OS === "ios"
              ? "tag_id=" + this.$route.params.tag_id
              : "id=" + this.$route.params.tag_id
          );
          break;
        case "newDetail":
          var data =
            window.OS === "ios"
              ? `pid=${this.$route.params.po_id}`
              : `id=${this.$route.params.po_id}&type=${this.$parent.poData.type}`;
          magicLink("po", data);
          break;
        default:
          magicLink("po", "xid=0");
          break;
      }
    },
  },
  mounted() {},
};
</script>



// WEBPACK FOOTER //
// DownloadNav.vue?a3de0fd0